import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { AddProductCard } from "./AddProductCard"
import { FileSpreadsheet, PenLine } from "lucide-react"
import { isBulkUploadEnabled } from "@/config/typedEnv"

interface AddProductStepOneProps {
  handleGoToStepTwo: (type?: string) => void
}

export const AddProductStepOne: React.FC<AddProductStepOneProps> = ({ handleGoToStepTwo }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <div className="flex flex-col gap-3 pt-2" data-testid="add-product-step-one">
      <AddProductCard
        testId="add-product-manual"
        variant="primary"
        badge={t("addProductStepOne.recommendedBadge")}
        icon={<PenLine className="h-5 w-5" />}
        title={t("addProductStepOne.manualTitle")}
        description={t("addProductStepOne.manualDescription")}
        onClick={() => navigate("/products/add")}
      />
      {isBulkUploadEnabled && (
        <AddProductCard
          testId="add-product-bulk"
          icon={<FileSpreadsheet className="h-5 w-5" />}
          title={t("addProductStepOne.bulkTitle")}
          description={t("addProductStepOne.bulkDescription")}
          onClick={() => handleGoToStepTwo("bulk")}
        />
      )}
    </div>
  )
}
